import { useFeatureTogglesStore } from 'stores/featureTogglesStore'
import {
  getNativePlatform,
  isNativeApp,
  isNativeAppVersionAtLeast,
  MIN_VERSION_FORCE_UPDATE_ARVORE,
  MIN_VERSION_FORCE_UPDATE_BIBLION,
  MIN_VERSION_OPEN_EXTERNAL_ARVORE,
  MIN_VERSION_OPEN_EXTERNAL_BIBLION
} from 'utils/native-app'
import type { AppVariant, ForceUpdateGateState } from './types'

const FORCE_UPDATE_TOGGLE = 'forceUpdateAppBlock'

const minVersionByVariant: Record<AppVariant, string> = {
  arvore: MIN_VERSION_FORCE_UPDATE_ARVORE,
  biblion: MIN_VERSION_FORCE_UPDATE_BIBLION
}

const openExternalMinVersionByVariant: Record<AppVariant, string> = {
  arvore: MIN_VERSION_OPEN_EXTERNAL_ARVORE,
  biblion: MIN_VERSION_OPEN_EXTERNAL_BIBLION
}

const storeUrlByVariant: Record<AppVariant, { android: string; ios: string }> =
  {
    arvore: {
      android:
        'https://play.google.com/store/apps/details?id=arvoredelivros.com.br.arvore',
      ios: 'https://apps.apple.com/app/id1094879125'
    },
    biblion: {
      android:
        'https://play.google.com/store/apps/details?id=br.com.arvore.biblion',
      ios: 'https://apps.apple.com/app/id6776347611'
    }
  }

const storeDeepLinkByVariant: Record<
  AppVariant,
  { android: string; ios: string }
> = {
  arvore: {
    android: 'market://details?id=arvoredelivros.com.br.arvore',
    ios: 'itms-apps://apps.apple.com/app/id1094879125'
  },
  biblion: {
    android: 'market://details?id=br.com.arvore.biblion',
    ios: 'itms-apps://apps.apple.com/app/id6776347611'
  }
}

export const useForceUpdateGate = (): ForceUpdateGateState => {
  const { featureToggles } = useFeatureTogglesStore()

  const variant: AppVariant =
    featureToggles?.biblionGeneral === true ||
    featureToggles?.biblionPanel === true
      ? 'biblion'
      : 'arvore'

  const platform = getNativePlatform()
  const storeUrls = storeUrlByVariant[variant]
  const storeDeepLinks = storeDeepLinkByVariant[variant]
  const storeUrl = platform === 'ios' ? storeUrls.ios : storeUrls.android
  const storeDeepLink =
    platform === 'ios' ? storeDeepLinks.ios : storeDeepLinks.android

  const isToggleOn = featureToggles?.[FORCE_UPDATE_TOGGLE] === true

  const isBlocked =
    isNativeApp() &&
    isToggleOn &&
    !isNativeAppVersionAtLeast(minVersionByVariant[variant])

  const canOpenExternal = isNativeAppVersionAtLeast(
    openExternalMinVersionByVariant[variant]
  )

  return { isBlocked, variant, storeUrl, storeDeepLink, canOpenExternal }
}
